<template>
  <!--<div v-bind:class="{ 'header header__black': this.black, 'header header__white': !this.black }">-->
    <div class="container">
    <!--<span>-->
    <input type="search" v-bind:class="{ 'search__black black': this.black, 'search__white white': !this.black }" @click="showHelper" @keyup.enter="submit" v-model="searchKeyword" placeholder="Typ hier je zoekterm en druk op enter">
    <div class="container__under">
      <div class="container__underleft" v-if="viewContent">
        <h2 v-bind:class="{ 'h2_black': this.black, 'h2_white': !this.black }">888zoeker (prototype)</h2>
        <ul>
          <li>Deze applicatie maakt de NPO inhoudelijk doorzoekbaar op basis van de ondertiteling.</li>
          <!-- <li>Gebruik ook de <a href="https://chrome.google.com/webstore/detail/achtachtachtfun/fmodplkopebakajogdkfhodjhcecabbb?hl=nl">Chrome-extensie</a> om direct naar het juiste fragment te gaan.</li> -->
          <li>0.8.0. <a href="https://www.notion.so/zummertime/Changelog-888-e61ea3402bd04b1cbbce90c9dfbc1e09">changelog</a> — development door <a href="https://www.erikvanzummeren.com" target="_blank">Erik van Zummeren</a></li>
          <li>Ge&iuml;nitieerd vanuit <a href="https://www.researchassistant.nl">researchassistant (ra)</a></li>
          <li>Feedback of vragen? Mail erikvanzummeren gmail com</li>
          <!-- <Newsletter/> -->
        </ul>
      </div>
      <!-- <div class="container__underright" v-if="viewContent"> -->

        <!-- <h2 v-bind:class="{ 'h2_black': this.black, 'h2_white': !this.black }">Search operators</h2>
        <ul>
          <li><span class="string">“Zwarte Piet”</span> — exact</li>
          <li><span class="string">Zwarte + piet</span> — resultaten met zowel zwarte en piet</li>
          <li><span class="string">-Feyenoord Ajax</span> — resultaten zonder Feyenoord</li>
          <li><span class="string">Feyenoord | Ajax</span> — Feyenoord of Ajax</li>
          <li><span class="string">Pegtold~</span> — fuzzy search, geeft Pechtold als resultaat</li>
          <li><span class="string">“Hoe dan”~3</span> — maximaal drie andere woorden tussen ‘hoe’ en ‘dan’</li>
          <li><span class="string">vis*~</span> — resultaten die beginnen met vis...</li>
        </ul> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Newsletter from './Newsletter'

export default {
  name: 'Header',
  components: {
    Newsletter
  },
  data: function () {
    return {
      searchKeyword: '',
      showFilters: false,
      isAsc: true,
      sort: 'desc'
    }
  },
  props: ['black', 'viewContent'],
  // computed: {
  //   settings () {
  //     return {
  //       viewFront: this.viewContent
  //     }
  //   }
  // },
  methods: {
    showHelper () {
      this.$emit('click', true)
    },
    submit () {
      this.$emit('enter', this.searchKeyword)
    },
    toggle: function () {
      this.showFilters = !this.showFilters
    },
    setBlack: function (bool) {
      console.log('tesrtttt')
      this.$emit('changeColor', bool)
    },
    setSort (sort) {
      if (sort === 'asc') {
        this.isAsc = true
      } else {
        this.isAsc = false
      }
      this.$emit('sorting', sort)
    }
  }
}
</script>

<style scoped>
  @media only screen
  and (min-device-width : 375px)
  and (max-device-width : 667px)
  and (orientation : portrait) {
    .container__underleft {
      width: 100% !important;
      /* position: initial !important; */
    }

    input[type=search] {
      font-size: 1.3rem !important;
    }
  }

.container {
  margin-top: 22%;
  width: 80%;
  margin-left: 10%;
  background: blue;
}

input[type=search] {
  color: white;
  border-style: none;
  border-bottom: 2px dotted white;
  border-radius: 0;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  font-family: 'fl-mono', sans-serif;
  font-size: 2rem;
  float: left;
  margin-right: 10px;
  position: relative;
  z-index: 1000;
}

.black::placeholder { /* Most modern browsers support this now. */
  color: white;
}

.white::placeholder { /* Most modern browsers support this now. */
  color: black;
}

.search__black { background:transparent; }
.search__white {
  background: transparent;
  color: rgb(241, 232, 232) !important;
}

.container__underleft {
  width: 50%;
  float: left;
}

.container__underright {
  width: 50%;
  float: right;
}

h2 {
  font-family: 'Feijoa-Medium', serif;
  font-weight: 100;
  color: white;
  font-size: 1.28571429rem;
  padding: 30px;
}

ul {
  list-style-type: none;
  padding-left: 30px
}

li {
  color: #707070;
  font-family: 'fl-mono', sans-serif;
  margin-top: 10px;
  font-size: 14px;
}

.string {
  background: #484848;
  color: #a7a7a7;
  padding: 3px 8px;
  border-radius: 5px;
}

a {
  color: #707070;
}

.h2_white {
  color: #707070;
}
</style>



// WEBPACK FOOTER //
// src/components/Frontpage.vue